import { PersonAvatar, rostoDoAutor, rostoDoDestinatario } from 'components/person-avatar';
import type { RecentRecognition } from 'pages/Dashboard/components/recent-recognitions';

interface RostosDoReconhecimentoProps {
  item: RecentRecognition;
  /** Diâmetro de cada rosto, em px. */
  tamanho: number;
  /** Classes das iniciais de quem enviou e de quem recebeu, no visual de cada tela. */
  iniciaisDoAutor: string;
  iniciaisDoDestinatario: string;
}

/**
 * Quem reconheceu e, sobreposto à direita com borda branca, quem recebeu (AJ3-19, AJ3-05). Decorativo: a tela
 * escreve os dois nomes ao lado.
 */
export function RostosDoReconhecimento({ item, tamanho, iniciaisDoAutor, iniciaisDoDestinatario }: RostosDoReconhecimentoProps) {
  // O destinatário começa a 20/34 do rosto do autor, como no Home.dc.html (34px, `left: 20px`).
  const deslocamento = Math.round((tamanho * 20) / 34);

  return (
    <span
      aria-hidden="true"
      data-testid="rostos-do-reconhecimento"
      className="relative block shrink-0"
      style={{ width: deslocamento + tamanho, height: tamanho }}
    >
      <span className="absolute left-0 top-0">
        <PersonAvatar {...rostoDoAutor(item)} initials={iniciaisDe(item.author)} size={tamanho} initialsClassName={iniciaisDoAutor} />
      </span>
      <span
        data-testid="rosto-do-destinatario"
        className="absolute top-0 box-content rounded-full border-2 border-solid border-brand-white"
        style={{ left: deslocamento - 2, top: -2 }}
      >
        <PersonAvatar
          {...rostoDoDestinatario(item)}
          initials={iniciaisDe(item.recipient)}
          size={tamanho}
          initialsClassName={iniciaisDoDestinatario}
        />
      </span>
    </span>
  );
}

/** "Priscila Nogueira" → "PN"; "Raquel" → "RA" (como o rosto do autor nos cartões de hoje). */
export function iniciaisDe(nome: string): string {
  const palavras = nome.trim().split(/\s+/).filter(Boolean);
  if (palavras.length >= 2) return `${palavras[0][0]}${palavras[palavras.length - 1][0]}`.toUpperCase();
  return nome.trim().slice(0, 2).toUpperCase();
}
